import React, { PureComponent } from 'react'
import {
  func, string, shape, bool,
} from 'prop-types'

import { withI18n } from '@active/react-utils/i18n'
import apis from './apis'
import { noop } from '../../../../shared/utils/commonUtils'
import TextHr from '../../../../components/common/TextHr'
import CountryChoose from '../../../../components/Signin/components/CountryChoose'
import ReagreeWaiver from '../../../../components/Signin/components/ReagreeWaiver'
import ReagreeWaiverConfirm from '../../../../components/Signin/components/ReagreeWaiverConfirm'
import { ErrorContent } from '../../../../components/common/Layout'
import FacebookButton from '../../../../components/common/Facebook/components/FacebookButton'
import './FacebookBtn.scss'
import connectLocale from '../../../../shared/utils/connectLocale'

const CHINESE_LOCALE = 'zh_CN'

const FacebookBtnBuilder = defaultProps => {
  const {
    actions: { signinSuccessCallback, signupSuccessCallback },
  } = defaultProps

  class FacebookBtn extends PureComponent {
    static propTypes = {
      locale: string.isRequired,
      i18n: func.isRequired,
      handleShowCoppaEmail: func,
      handleCreateAccount: func,
      handleBindAccount: func,
      countryCodes: string,
      clientConfig: shape({
        suppressActiveWaiver: bool,
        useCustomizeWaiver: bool,
        waiverAttachementObjectIds: string,
      }).isRequired,
      facebookText: string.isRequired,
    }

    static defaultProps = {
      handleShowCoppaEmail: noop,
      handleCreateAccount: noop,
      handleBindAccount: noop,
      countryCodes: undefined,
    }

    constructor(props) {
      super(props)
      const { locale } = props
      if (CHINESE_LOCALE !== locale) {
        this.apis = apis(defaultProps)
      }
      this.state = {
        selectedCountryCode: '',
        isCountryChooseShow: false,
        isReagreeWaiverShow: false,
        isReagreeWaiverConfirmShow: false,
        isBack: false,
        resetAgrees: false,
      }
    }

    componentWillUnmount() {
      if (this.countryChooseTimer) {
        clearTimeout(this.countryChooseTimer)
      }
      if (this.reagreeWaiverTimer) {
        clearTimeout(this.reagreeWaiverTimer)
      }
      if (this.reagreeWaiverConfirmTimer) {
        clearTimeout(this.reagreeWaiverConfirmTimer)
      }
    }

    handleComplete = ({ loginURL, ssoToken }) => {
      const { locale } = this.props
      const lowerPiorityRedirectUrl = new URL(loginURL)
      lowerPiorityRedirectUrl.searchParams.append('ssoToken', ssoToken)
      lowerPiorityRedirectUrl.searchParams.append('locale', locale)
      window.location.href = lowerPiorityRedirectUrl.href
    }

    handleFacebookSignin = () => {
      const {
        handleCreateAccount, handleBindAccount,
        handleShowCoppaEmail, countryCodes,
        clientConfig,
      } = this.props
      const {
        facebookLogin, facebookBindAccount, facebookCreateAccount,
      } = this.apis

      this.setState({
        showError: false,
        errorMsg: '',
      })

      facebookLogin({
        clientConfig,
        handleCoppa: ({ pendingKey }) => {
          handleShowCoppaEmail(true, pendingKey)
        },
        handleError: ({ errorMsg }) => {
          this.setState({
            showError: true,
            errorMsg,
          })
        },
        handleNoCountryCode: ({ facebookSign }) => {
          this.setState({
            isCountryChooseShow: true,
            facebookSign,
          })
        },
        handleWaiverExpired: ({ response: { accountCountryCode }, facebookSign }) => {
          const { selectedCountryCode } = this.state

          this.setState({
            resetAgrees: true,
            isReagreeWaiverShow: true,
            facebookSign,
            isBack: !!selectedCountryCode,
            selectedCountryCode: accountCountryCode,
          })
        },
        login: ({
          email, loginURL, ssoToken, ...rest
        }) => {
          this.resetWaiver()
          if (signinSuccessCallback) {
            signinSuccessCallback({
              email: email, loginURL, ssoToken, ...rest,
            })
          } else {
            this.handleComplete({ loginURL, ssoToken })
          }
        },
        createAccount: response => handleCreateAccount({
          response,
          facebookCreateAccount,
          countryCodes,
          signupSuccessCallback,
          defaultHandleComplete: this.handleComplete,
          clientConfig,
        }),
        bindAccount: response => handleBindAccount({
          response,
          facebookBindAccount,
          countryCodes,
          signinSuccessCallback,
          defaultHandleComplete: this.handleComplete,
          clientConfig,
        }),
      })
    }

    /** modal start */
    /** countryChoose start */
    handleChangeCountry = value => {
      this.setState({
        selectedCountryCode: value,
      })
    }

    handleCountryChooseSubmit = () => {
      const { selectedCountryCode, facebookSign } = this.state
      facebookSign({
        selectedCountryCode,
      })
    }
    /** countryChoose end */

    /** ReagreeWaiver  start */
    handleReagreeWaiverClose = () => {
      this.setState({
        isReagreeWaiverShow: false,
      }, () => {
        this.reagreeWaiverConfirmTimer = setTimeout(() => {
          this.setState({
            isReagreeWaiverConfirmShow: true,
          })
        }, 500)
      })
    }

    handleReagreeWaiverSubmit = () => {
      const { selectedCountryCode, facebookSign } = this.state
      facebookSign({
        selectedCountryCode,
        reagree: true,
      })
    }

    handleBack = () => {
      this.setState({
        isReagreeWaiverShow: false,
      }, () => {
        this.countryChooseTimer = setTimeout(() => {
          this.setState({
            isCountryChooseShow: true,
          })
        }, 500)
      })
    }

    handleReagreeWaiverCheckboxChange = () => {
      this.setState({
        resetAgrees: false,
      })
    }

    /** ReagreeWaiver  end */

    /** ReagreeWaiverConfirm  start */
    resetWaiver = () => {
      this.setState({
        isReagreeWaiverConfirmShow: false,
        isReagreeWaiverShow: false,
        isCountryChooseShow: false,
        selectedCountryCode: undefined,
        resetAgrees: true,
      })
    }

    handleCancel = () => {
      this.setState({
        isReagreeWaiverConfirmShow: false,
      }, () => {
        this.reagreeWaiverTimer = setTimeout(() => {
          this.setState({
            isReagreeWaiverShow: true,
          })
        }, 500)
      })
    }
    /** ReagreeWaiverConfirm  end */

    /** modal end  */

    render() {
      const {
        errorMsg,
        showError,
        isBack,
        selectedCountryCode,
        isCountryChooseShow,
        isReagreeWaiverShow,
        isReagreeWaiverConfirmShow,
        resetAgrees,
      } = this.state

      const { locale, i18n, facebookText } = this.props

      if (locale === CHINESE_LOCALE) {
        return null
      }
      return (
        <>
          <CountryChoose
            isCountryChooseShow={isCountryChooseShow}
            handleChangeCountry={this.handleChangeCountry}
            handleCountryChooseModalClose={this.resetWaiver}
            handleCountryChooseSubmit={this.handleCountryChooseSubmit}
          />
          <ReagreeWaiver
            isBack={isBack}
            selectedCountryCode={selectedCountryCode}
            isReagreeWaiverShow={isReagreeWaiverShow}
            handleReagreeWaiverClose={this.handleReagreeWaiverClose}
            handleReagreeWaiverSubmit={this.handleReagreeWaiverSubmit}
            handleBack={this.handleBack}
            resetAgrees={resetAgrees}
            handleReagreeWaiverCheckboxChange={this.handleReagreeWaiverCheckboxChange}
            {...this.props}
          />
          <ReagreeWaiverConfirm
            handleReagreeWaiverConfirmClose={this.resetWaiver}
            isReagreeWaiverConfirmShow={isReagreeWaiverConfirmShow}
            handleCancel={this.handleCancel}
            handleClose={this.resetWaiver}
          />

          {showError && <ErrorContent errorMsg={errorMsg} />}
          <div className="passport__facebook">
            <TextHr id={i18n('passport.common.text.or')} className="text-uppercase" />
            <FacebookButton facebookText={facebookText} onFacebookSignin={this.handleFacebookSignin} />
          </div>
        </>
      )
    }
  }
  return withI18n(connectLocale(FacebookBtn))
}

export default FacebookBtnBuilder
